import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const KeyGlyph = /*#__PURE__*/createElement("g", {
  id: "key"
}, /*#__PURE__*/createElement("path", {
  d: "M63.5,24.7c-3.8-3.8-9.1-5.7-14.5-5.1c-7.8,0.8-14.2,6.8-15.5,14.6c-0.5,2.9-0.3,5.8,0.6,8.6L19.8,57 c-0.2,0.2-0.4,0.5-0.4,0.8l-1.1,7.2c-0.2,1.3,0.2,2.6,1.1,3.6c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0.1,0.1,0.1c0.8,0.8,1.9,1.3,3,1.3 c0.2,0,0.4,0,0.6,0l7.2-1c0.3,0,0.6-0.2,0.8-0.4l3.2-3.2c0.3-0.3,0.5-0.7,0.4-1.2l-0.1-1c0-0.2,0.1-0.4,0.2-0.5 c0.1-0.1,0.2-0.2,0.5-0.2l1.1,0.1c0.4,0,0.8-0.1,1.2-0.4l3.8-3.8c0.2-0.2,0.4-0.5,0.4-0.9l0.1-1.5c0-0.1,0.1-0.1,0.1-0.1l1.2,0 c0.4,0,0.7-0.2,1-0.4l1.2-1.2c2.8,0.9,5.7,1.1,8.6,0.6c7.7-1.4,13.7-7.8,14.6-15.5C69.1,33.8,67.3,28.5,63.5,24.7z M65.7,38.9 c-0.7,6.5-5.7,11.9-12.2,13c-2.7,0.5-5.3,0.2-7.9-0.8c-0.5-0.2-1.1-0.1-1.5,0.3l-1.5,1.5l-0.6,0c-1.5,0-2.8,1.2-2.9,2.7l-0.1,1 L36,59.5l-0.4,0c-1-0.1-2,0.3-2.8,1c-0.7,0.7-1.1,1.8-1,2.8l0,0.3L29.5,66L23,67l17.8-17.8c0.6-0.6,0.6-1.5,0-2 c-0.6-0.6-1.5-0.6-2,0L21.2,64.7l0.9-6l14.6-14.6c0.4-0.4,0.5-1,0.3-1.5c-1-2.6-1.2-5.2-0.8-7.9c1.2-6.5,6.5-11.5,13-12.2 c4.5-0.5,9,1.1,12.1,4.3C64.6,29.9,66.2,34.3,65.7,38.9z"
}), /*#__PURE__*/createElement("path", {
  d: "M54.5,28.2c-3,0-5.5,2.5-5.5,5.5s2.5,5.5,5.5,5.5s5.5-2.5,5.5-5.5S57.5,28.2,54.5,28.2z M54.5,36.2c-1.4,0-2.5-1.1-2.5-2.5 s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S55.9,36.2,54.5,36.2z"
}));
const Key = createSvg({
  name: 'key',
  path: KeyGlyph
});

export default Key;
export { KeyGlyph };
